<template>
  <div class="ca-label-monto" :style="{'width': width}" :class="{'ca-label-monto--bold': monto_bold}">
    <div class="ca-label-monto-prefix" :style="{'font-size': prefix_size+'px'}">$</div>
    <div class="ca-label-monto-valor" :style="{'font-size': monto_size+'px'}">{{monto | formatMontoCentavos}}</div>
  </div>
</template>
<script>
export default {
  props: {
    monto: {type: Number, default: 0},
    ancho: {type: Number, default: 100},
    monto_bold: {type: Boolean, default: false},
    monto_size: {type: Number, default: 14},
    prefix_size: {type: Number, default: 12},
    ancho_auto: {type: Boolean, default: false}
  },
  computed: {
    width() {
      return this.ancho_auto ? 'fit-content' : (this.ancho + 'px');
    }
  }
};
</script>
<style lang="scss">
  .ca-label-monto {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }
  .ca-label-monto-prefix {
    color: color(gris-deshabilitado);
  }
  .ca-label-monto-valor {
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 10px;
  }
  .ca-label-monto--bold {
    .ca-label-monto-valor {
      font-weight: bold;
    }
  }
</style>
